import { AbstractEditService } from '@/core/services/edit.service'
import { AbstractListService } from '@/core/services/list.service'
import { ListFetchOptions } from '@/core/typing'

class List extends AbstractListService<Store> {
  size = 50
  getFetchURL(): string {
    return 'black_app/list'
  }
}

class Edit extends AbstractEditService<Store> {
  getFetchURL() {
    return `black_app/${this.params.id}`
  }
  getSubmitURL(): string {
    return this.isEdit ? `black_app/modify/${this.params.id}` : 'black_app/add'
  }
  getRemoveURL(): string {
    return `black_app/${this.params.id}`
  }
  requestListReload(option?: ListFetchOptions): void {
    this.context.list.fetch(option)
  }
}

class Store {
  list: List
  edit: Edit

  constructor() {
    this.list = new List(this)
    this.edit = new Edit(this)
  }
}

export const store = new Store()
